// extracted by mini-css-extract-plugin
export default {"constructionIsActive":"acceptedCell_constructionIsActive__FaFbg","isAccepted":"acceptedCell_isAccepted__2GtkD"};